import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import GridTicketModalForm from './grid-ticket-modal-form'

import styles from './grid-ticket-modal.css'

const GridTicketModal = ({ onCreateTicket, onEditTicket, onCancelTicket, currentEditSellableItemId }) => (
  <div styleName="content">
    <GridTicketModalForm
      onCancel={onCancelTicket}
      onSubmit={currentEditSellableItemId ? onEditTicket : onCreateTicket}
      currentEditSellableItemId={currentEditSellableItemId}
    />
  </div>
)

GridTicketModal.propTypes = {
  onCancelTicket: PropTypes.func.isRequired,
  onCreateTicket: PropTypes.func.isRequired,
  onEditTicket: PropTypes.func.isRequired,
  currentEditSellableItemId: PropTypes.number,
}

export default CSSModules(GridTicketModal, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-ticket-modal/grid-ticket-modal.js
 **/